import { adminHttpClient } from '../../commons/adminHttpClient'
import OrderedPageFilter from '../../commons/orderedPageFilter'
import PagedList from '../../commons/PagedList'
import { Employee } from '../prospectSignup/step3/question1'

export const uploadCensusTemplate = (request: FormData): Promise<any> =>
  adminHttpClient.put('/IchraDecisionTool/EmployeeCensus', request, {
    headers: {
      'Content-Type': 'text/csv',
    },
  })

export interface PagedEmployees extends PagedList<Employee> {}

export const getEmployees = (id: string, filter: OrderedPageFilter): Promise<PagedEmployees> => {
  filter = filter || {
    pageNumber: 1,
    pageSize: 10,
    orderColumn: 'identifier',
    orderDescending: true,
  }
  return adminHttpClient.get('/IchraDecisionTool/EmployeeCensus', { ...filter, prospectId: id })
}

export const finishSignup = (id: string): Promise<any> => {
  return adminHttpClient.post('/IchraDecisionTool/EmployeeCensus/FinishApplication', {
    id: id,
  })
}
